import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import BackgroundTimeZone from '../../../domain/entities/BackgroundTimeZone';

export default function reducer(
  state: {[key: number]: BackgroundTimeZone} = {},
  action: AnyAction,
): {[key: number]: BackgroundTimeZone} {
  switch (action.type) {
    case Types.IndexBackgroundTimeZonesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: BackgroundTimeZone},
            record: BackgroundTimeZone,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
